import { UserAttributionDto } from "@nestcoinco/hyper-api-gateway-api-client";

import {
  setStoredAttribution,
  getStoredAttribution,
  deleteStoredAttribution,
} from "./storage";
import { TTL } from "./constants";

const ATTRIBUTION_TTL_MS = TTL.DAYS(7);
const MAX_ATTRIBUTION_HISTORY = 10;

type AttributionTouchpoint = Omit<UserAttributionDto, "metadata">;

function isExpired(data: UserAttributionDto): boolean {
  const createdAt = new Date(data.cookieCreatedAt).getTime();
  if (Number.isNaN(createdAt)) return true;
  return Date.now() - createdAt > ATTRIBUTION_TTL_MS;
}

export function clearAttributionData(): void {
  deleteStoredAttribution();
}

export function setAttributionData(data: UserAttributionDto): void {
  setStoredAttribution(data);
}

export function getAttributionData(): UserAttributionDto | null {
  const data = getStoredAttribution<UserAttributionDto>();

  if (!data) return null;

  if (isExpired(data)) {
    clearAttributionData();
    return null;
  }

  return data;
}

export function captureUtmParams(): void {
  const { searchParams, origin, pathname } = new URL(window.location.href);

  const utmSource = searchParams.get("utm_source");
  const utmMedium = searchParams.get("utm_medium");
  const utmCampaign = searchParams.get("utm_campaign");

  if (!utmSource && !utmMedium && !utmCampaign) return;

  const existing = getAttributionData();
  const now = new Date().toISOString();
  const baseUrl = `${origin}${pathname}`;

  if (!existing) {
    setAttributionData({
      utmSource,
      utmMedium,
      utmCampaign,
      baseUrl,
      cookieCreatedAt: now,
      isOrganic: false,
    });
    return;
  }

  const hasChanged =
    utmSource !== existing.utmSource ||
    utmMedium !== existing.utmMedium ||
    utmCampaign !== existing.utmCampaign;

  if (!hasChanged) return;

  const { metadata, ...archivedTouchpoint } = existing;
  const previousHistory = (metadata?.history as AttributionTouchpoint[]) ?? [];

  setAttributionData({
    utmSource,
    utmMedium,
    utmCampaign,
    baseUrl,
    cookieCreatedAt: now,
    isOrganic: false,
    metadata: {
      history: [
        archivedTouchpoint as AttributionTouchpoint,
        ...previousHistory,
      ].slice(0, MAX_ATTRIBUTION_HISTORY),
    },
  });
}
